import React from 'react';
import './MoveHistoryOverlay.css';

// Mobile move-history overlay. Shows moves from gameState.moveHistory in
// two-column (white/black pair) rows, most-recent first. Tap the scrim or
// the close button to dismiss.
export default function MoveHistoryOverlay({ open, onClose, gameState }) {
  if (!open) return null;

  const moves = gameState?.moveHistory || [];
  // Pair moves into rows [white, black].
  const rows = [];
  for (let i = 0; i < moves.length; i += 2) {
    rows.push({ number: Math.floor(i / 2) + 1, white: moves[i], black: moves[i + 1] || null });
  }

  const notation = (m) => {
    if (!m) return '—';
    if (m.algebraic_notation) return m.algebraic_notation;
    const files = ['a','b','c','d','e','f','g','h','i'];
    const ranks = ['1','2','3','4','5','6','7','8','9'];
    const fr = m.from?.row ?? m.from_row;
    const fc = m.from?.col ?? m.from_col;
    const tr = m.to?.row ?? m.to_row;
    const tc = m.to?.col ?? m.to_col;
    if (fr == null || fc == null || tr == null || tc == null) return '?';
    return `${files[fc]}${ranks[fr]}→${files[tc]}${ranks[tr]}`;
  };

  return (
    <div className="mh-scrim" onClick={onClose} role="dialog" aria-modal="true">
      <div className="mh-overlay" onClick={(e) => e.stopPropagation()}>
        <div className="mh-header">
          <h2>Move History</h2>
          <button className="mh-close" onClick={onClose} aria-label="Close">×</button>
        </div>
        <div className="mh-body">
          {rows.length === 0 ? (
            <p className="mh-empty">No moves yet.</p>
          ) : (
            <table className="mh-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>White</th>
                  <th>Black</th>
                </tr>
              </thead>
              <tbody>
                {rows.slice().reverse().map((r) => (
                  <tr key={r.number}>
                    <td className="mh-num">{r.number}</td>
                    <td>{notation(r.white)}</td>
                    <td>{notation(r.black)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}
